export enum ChangeItemType {
  SCOPE_SECTION = 'SCOPE_SECTION',
  SCOPE_FEE_ITEM = 'SCOPE_FEE_ITEM',
  DELIVERABLE = 'DELIVERABLE',
  DELIVERABLE_SECTION = 'DELIVERABLE_SECTION',
  DELIVERABLE_FEE_ITEM = 'DELIVERABLE_FEE_ITEM',
  COMPONENT = 'COMPONENT',
  SCENARIO_CONFIGURATION = 'SCENARIO_CONFIGURATION',
}
